import React, { useEffect, useState } from "react";
import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';

import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";

import CloseIcon from '@mui/icons-material/Close';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { buttonRed, dialogEditEvent, lightcolor, pcolor, pointer, primaryColor, rcolor, whitecolor } from "../../style2";

function JournalEntryUploadFile({ onClose, onSaved }) {
  const [file, setFile] = useState(null);
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  return <Dialog open={true} onClose={onClose} maxWidth="xs" fullWidth>
    <Box sx={{...dialogEditEvent, backgroundColor: lightcolor, border: "1px solid #D9D9D9" }}>
      <Grid container xs={12} align="center" sx={{ textAlign: "left" }}>
        <Grid item xs={11}>
          <Typography sx={{ color: pcolor, fontWeight: "bold", fontSize: "20px", textTransform: "capitalize" }}>
            Add Attachment
          </Typography>
        </Grid>
        <Grid item xs={1} sx={{ color: rcolor, textAlign: "right", cursor: "pointer" }}>
          <CloseIcon onClick={onClose} sx={{ width: "35px", height: "35px" }} />
        </Grid>
      </Grid>
      <DialogContent sx={{ padding: "5px" }}>
        <div style={{ backgroundColor: whitecolor, padding: "5px" }}>
          <Box sx={{ padding: "8px", marginTop: "10px" }}>
            <label style={{ color: pcolor, display: "block", fontWeight: "bold", marginBottom: "10px" }}>Upload File</label>
            <input type="file" accept=".jpg, .png, .doc, .docx, .jpeg, .pdf, .mov, .mp3, .mp4" onChange={(e) => {
              if (e.target.files.length > 0) {
                setFile(e.target.files[0]);
                setName(e.target.files[0].name);
                setError("");
              }
            }} />
          </Box>
          {file != null ? <Box sx={{ padding: "8px", marginTop: "10px" }}>
            <label style={{ color: pcolor, display: "block", fontWeight: "bold", marginBottom: "10px" }}>File Name</label>
            <TextField variant="outlined" placeholder="Write something here." fullWidth multiline={true} maxRows={4} value={name} onChange={(e) => { setName(e.target.value); }} />
          </Box> : null}
          {error !== "" ? <Box sx={{textAlign:"center", color:"red", padding:"4px"}}>{error}</Box> : null}
        </div>
        <Box sx={{ padding: "8x", marginTop: "10px", textAlign: "center" }}>
          <Button type="button" sx={buttonRed} onClick={() => { 
            if(file == null){
              setError("Please choose a file.");
              return;
            }
            if(name == null || name === ""){
              setError("Please provide a file name.");
              return;
            }
            onSaved({ file, name }); }}>Save</Button>
        </Box>
      </DialogContent>
    </Box>
  </Dialog>;
}

function IndicatorPanel({ indicator, chk, onSelect, onUnselect }) {
  const [checked, setChecked] = useState(chk);
  return (<div style={{ padding: "0px" }}>
    <FormControlLabel control={<Checkbox checked={checked} onChange={(event) => {
      setChecked(event.target.checked);
      if (event.target.checked)
        onSelect(indicator.id);
      else
        onUnselect(indicator.id);
    }} />} label={indicator.name} />

  </div>);
}

function SymptomPanel({ symptom, chk, indicators, onSelect, onUnselect, onSelectIndicator, onUnselectIndicator, selectedIndicators }) {
  const [checked, setChecked] = useState(chk);
  let indicatosshtml = [];
  for (let i in indicators) {
    let s = indicators[i];
    indicatosshtml.push(<IndicatorPanel indicator={s} chk={selectedIndicators.length > 0 && selectedIndicators.filter(t => t.id === s.id).length > 0}
      onSelect={(id) => { onSelectIndicator(id); }}
      onUnselect={(id) => { onUnselectIndicator(id); }} />);
  }
  return (<>
    <div style={{ padding: "0px", borderBottom: "1px solid #F6F6F6" }}>
      <FormControlLabel control={<Checkbox checked={checked} onChange={(event) => {
        setChecked(event.target.checked);
        if (event.target.checked)
          onSelect(symptom.journalTagID);
        else
          onUnselect(symptom.journalTagID);
      }} />} label={symptom.tagName} />
      {checked ? <Box style={{ paddingLeft: "30px" }}>{indicatosshtml}</Box> : null}
    </div>
  </>);
}

function MedicalConditionPanel({ mc, onSelectSymptom, onUnselectSymptom, onSelectIndicator, onUnselectIndicator, selectedtags, selectedIndicators }) {
  const [expanded, setExpanded] = useState(false);
  let symptomshtml = [];
  for (let i in mc.symptoms) {
    let s = mc.symptoms[i];
    let indcs = mc.indicators.filter(t => t.journalTagID === s.journalTag.journalTagID);
    symptomshtml.push(<SymptomPanel symptom={s.journalTag} chk={selectedtags.length > 0 && selectedtags.filter(t => t.medicalcondition.id === mc.id && t.symptom.journalTagID === s.journalTagID).length > 0} indicators={indcs} onSelect={(id) => { onSelectSymptom(id) }} onUnselect={(id) => { onUnselectSymptom(mc.id, id) }} onSelectIndicator={(id) => { onSelectIndicator(id) }} onUnselectIndicator={(id) => { onUnselectIndicator(id); }} selectedIndicators={selectedIndicators} />);
  }
  return (<>
    <div style={{ background: whitecolor, padding: "8px", marginBottom: "10px", marginTop: "10px", borderRadius: "10px" }}>
      <Grid container fullWidth sx={pointer} onClick={() => { setExpanded(!expanded) }}>
        <Grid item xs={11}>
          <Typography sx={{ color: pcolor, fontWeight: "bold", fontSize: "18px", textTransform: "capitalize" }}>
            {mc.name}
          </Typography>
        </Grid>
        <Grid xs={1} >
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Grid>
      </Grid>
      <div style={expanded ? { display: "none" } : {}}>{symptomshtml}</div>
    </div>
  </>);
}

export default function JournalEntry(props) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const ls = new AccessLocalStorage();
  const [journalDate, setJournalDate] = useState(dayjs());
  const [files, setFiles] = useState([]);
  const [selectedTags, setJournalTags] = useState([]);
  const [selectedIndicators, setIndicators] = useState([]);
  const [note, setNote] = useState("");
  const [medicalConditions, setMedicalConditions] = useState(null);
  const [symptoms, setSymptomsList] = useState([]);
  const [indicators, setIndicatorsList] = useState([]);
  const [showMedConditionsModal, setShowMedicalConditionModal] = useState(false);
  const [showFileUploadModal, setShowFileUploadModal] = useState(false);
  const [journalDateValidMessage, setJournalDateValidMessage] = useState("");
  const [noteValidMessage, setNoteValidMessage] = useState("");

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }

    fetch(
      `${getApiUrl()}${process.env.REACT_APP_GET_MEDICALCONDITION}`,
      { method: "GET", headers: { Authorization: `Bearer ${token}` } }
    )
      .then((response) => response.json())
      .then((data) => {
        //console.log(data);
        setMedicalConditions(data);
        let temp = [];
        let temp2 = [];
        for (let i in data) {
          try {
            for (let k in data[i].symptoms) {
              temp.push(data[i].symptoms[k].journalTag);
            }
          } catch (err) { }
          try {
            for (let k in data[i].indicators) {
              temp2.push(data[i].indicators[k]);
            }
          } catch (err) { }
        }
        setSymptomsList(temp);
        setIndicatorsList(temp2);
      })
      .catch((err) => { setError(err.message || "An error occurred."); })
      .finally(() => { setLoading(false); });
  }, []);

  const saveJournalEntry = () => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }
    if (journalDate === null || journalDate === "") {
      setJournalDateValidMessage("Date is required");
      return;
    }
    if (note === null || note === "") {
      setNoteValidMessage("Note is required");
      return;
    }
    setLoading(true);
    setError("");
    let tagids = [];
    let indicatorids = [];
    for (let k in selectedTags) {
      tagids.push(selectedTags[k].symptom.journalTagID);
    }
    for (let k in selectedIndicators) {
      indicatorids.push(selectedIndicators[k].id);
    }
    let url = `${getApiUrl()}/journal/${ls.getCurrentPatientId()}`;
    // if(id != 0){
    //   url = `${getApiUrl()}/journal/update/${ls.getCurrentPatientId()}/${id}`;
    // }
    const fd = new FormData();
    fd.append("journalDate", journalDate);
    fd.append("Note", note);
    fd.append("isImportant", false);
    files.forEach((item, i) => {
      fd.append(`file${i + 1}`, item.file, item.file.name);
      fd.append(`filename${i + 1}`, item.name);
    });
    tagids.forEach((tag, i) => {
      fd.append(`tags[${i}]`, tag);
    });
    indicatorids.forEach((indicatorid, i) => {
      fd.append(`indicators[${i}]`, indicatorid);
    });
    fetch(url,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: fd
      }
    )
      .then((response) => {
        if (response.status === 200) {
          setNote('');
          setNoteValidMessage('');
          setJournalDate(dayjs());
          setFiles([]);
          setJournalTags([]);
          setIndicators([]);
          setError("");
          props.successClose();
        }
        else {
          response.json().then(data => {
            setError(data.error);
          }).catch(err => {
            setError(err.message || "An error occurred.");
            console.log(err);
          });
        }
      })
      .catch((err) => { setError(err.message || "An error occurred."); console.log(err); })
      .finally(() => { setLoading(false); });
  }

  const renderMedicalConditionModal = () => {
    if (showMedConditionsModal) {
      return (<Dialog open={showMedConditionsModal} onClose={() => { setShowMedicalConditionModal(false); }} maxWidth="sm" fullWidth>
        <Box sx={{...dialogEditEvent, backgroundColor: whitecolor, border: "0px" }}>
          <Grid container xs={12} align="center" sx={{ textAlign: "left" }}>
            <Grid item xs={11}>
              <Typography sx={{ color: pcolor, fontWeight: "bold", fontSize: "20px", textTransform: "capitalize" }}>
                Select Symptoms
              </Typography>
            </Grid>
            <Grid item xs={1} sx={{ color: rcolor, cursor: "pointer" }}>
              <CloseIcon onClick={() => { setShowMedicalConditionModal(false); }} sx={{ width: "35px", height: "35px" }} />
            </Grid>
          </Grid>
          <DialogContent sx={{ padding: "5px" }}>
            <div style={{ minHeight: "380px", maxHeight: "500px", overflowY: "auto", backgroundColor: lightcolor, borderRadius: "10px", padding: "10px" }}>
              {medicalConditions.map(mc => {
                return <MedicalConditionPanel mc={mc} selectedtags={selectedTags} selectedIndicators={selectedIndicators} onSelectSymptom={(id) => {
                  if ((selectedTags.length > 0 && selectedTags.filter(t => t.symptom.id === id).length == 0) || selectedTags.length === 0) {
                    selectedTags.push({ medicalcondition: mc, symptom: symptoms.filter(t => t.journalTagID === id)[0] });
                    setJournalTags(selectedTags);
                  }
                }} onUnselectSymptom={(mcid, id) => {
                  if (selectedTags.length > 0) {
                    let temp = selectedTags.filter(t => !(t.medicalcondition.id === mcid && t.symptom.journalTagID === id));
                    setJournalTags(temp);
                  }

                  //remove all indicators of this symptom as well
                  if (selectedIndicators.length > 0) {
                    setIndicators(selectedIndicators.filter(t => t.journalTag.journalTagID !== id));
                  }
                }}
                  onSelectIndicator={(id) => {
                    if (selectedIndicators.length == 0 || (selectedIndicators.length > 0 && selectedIndicators.filter(t => t.id === id).length == 0)) {
                      selectedIndicators.push(indicators.filter(t => t.id == id)[0]);
                      setIndicators(selectedIndicators);
                    }
                  }}
                  onUnselectIndicator={(id) => {
                    if (selectedIndicators.length > 0) {
                      let temp = selectedIndicators.filter(t => t.id !== id);
                      setIndicators(temp);
                    }
                  }} />;
              })}
            </div>
            <Box sx={{ padding: "8x", marginTop: "10px", textAlign: "center" }}>
              <Button type="button" sx={buttonRed} disabled={loading} onClick={() => { setShowMedicalConditionModal(false); }}>Save</Button>
            </Box>
          </DialogContent>
        </Box>
      </Dialog>);
    }
    return null;
  };

  const handleDailogClose = () => {
    setNote('');
    setNoteValidMessage('');
    setJournalDate(dayjs());
    setFiles([]);
    setJournalTags([]);
    setIndicators([]);
    setError("");
    props.handleClose();
  }

  const handleFileChange = (e) => {
    if (files.length >= 3) {
      setError("Only 3 files allowed.");
      return;
    }
    files.push(e);
    setFiles(files);

  };

  const renderFiles = () => {
    return <Grid container fullWidth>
      {files.map((item, k) => {
        return (
          <Grid item xs={2} key={k} sx={{...primaryColor, position: "relative", display: "inline-block", marginRight: "10px", padding: "10px" }} >
            <div style={{ textAlign: "center" }}>
              {item.file.type === "video/mp4" || item.file.type === "video/quicktime" ?
                <video src={URL.createObjectURL(item.file)} style={{ maxWidth: "100%", height: "auto", maxHeight: "80px" }} /> : null}
              {item.file.type === "application/msword" || item.file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                ? <DescriptionIcon style={{ fontSize: "4rem" }} /> : null}
              {item.file.type === "application/pdf"
                ? <PictureAsPdfIcon style={{ fontSize: "4rem" }} /> : null}
              {item.file.type === "image/jpeg" || item.file.type === "image/png"
                ? <img src={URL.createObjectURL(item.file)} style={{ maxWidth: "100%", height: "auto", maxHeight: "80px" }} /> : null}
              {item.file.type === "audio/mpeg" || item.file.type === "audio/wav"
                ? <audio src={URL.createObjectURL(item.file)} style={{ maxWidth: "100%", height: "auto", maxHeight: "60px" }} /> : null}
            </div>
            <div style={{ fontSize: "0.7rem", textAlign: "center", overflowWrap: "break-word" }}>
              {item.name}
            </div>
            <IconButton disabled={loading} component="label"
              variant="outlined" onClick={() => {
                setFiles(files.filter(t => t.file.name != item.file.name));
                //setFileCount(files.length);
              }} size="small" sx={{...primaryColor, position: "absolute", right: "-10px", top: "-10px" }}>
              <CloseIcon style={{ fontSize: "1.5rem" }} />
            </IconButton>
          </Grid>
        );
      })}
      {files.length < 3 ? <Grid item xs={2} sx={{...primaryColor, cursor: "pointer", padding: "10px" }}  onClick={() => { if (!loading) { setShowFileUploadModal(true); } }}>
        <AddOutlinedIcon style={{ fontSize: "3rem" }} />
      </Grid> : null}
    </Grid>;
  }

  const getColor = (k) => {
    let bgcolor = "#38B6FF";
    let color = "#fff";
    switch (k) {
      case "Sleep":
        bgcolor = "#A46979";
        break;
      case "Inattention":
        bgcolor = "#ED8797";
        break;
      case "Hyperactivity":
        bgcolor = "#8C52FF";
        break;
      case "Behavior", "Appointment":
        bgcolor = "#E499DE";
        break;
      case "Social communication":
        bgcolor = "#7B9390";
        break;
      case "Posture":
        bgcolor = "#FFBD59";
        break;
      case "Sensory":
        bgcolor = "#95D9A5";
        color = pcolor;
        break;
    }
    return { bgcolor, color };
  }

  const renderSelectedSymptoms = () => {
    let items = [];
    for (let l in medicalConditions) {
      let mc = medicalConditions[l];
      for (let i in mc.symptoms) {
        if (selectedTags.filter(t => t.medicalcondition.id == mc.id && t.symptom.journalTagID == mc.symptoms[i].journalTagID).length > 0) {
          let tag = mc.symptoms[i];
          items.push(<>
            <div style={{
              color: getColor(tag.journalTag.tagName).bgcolor, fontWeight: "bold",
              padding: "5px 15px", margin: "5px", borderRadius: "15px", fontSize: "15px"
            }}>{mc.name} - {tag.journalTag.tagName}
            </div>
            {renderSelectedIndicators(mc, tag)}
          </>);
        }
      }
    }

    if (items.length > 0)
      return items;
    else
      return "Choose";
  }

  const renderSelectedIndicators = (mc, symptom) => {
    let items = [];
    let filtered = mc.indicators.filter(t => t.journalTagID === symptom.journalTagID);
    for (let k in filtered) {
      let indicator = filtered[k];
      if (selectedIndicators.filter(t => t.id === indicator.id).length > 0) {
        items.push(<Grid container direction="row" alignItems="flex-start" justifyContent="flex-start"
          style={{ padding: "8px 20px", fontSize: "17px" }}>
          <CheckBoxOutlinedIcon style={{ marginRight: "10px" }} />
          {indicator.name}
        </Grid>);
      }
    }
    return items;
  }

  return (<>
    {renderMedicalConditionModal()}
    {showFileUploadModal ? <JournalEntryUploadFile onClose={() => { setShowFileUploadModal(false); }} onSaved={(data) => { handleFileChange(data); setShowFileUploadModal(false); }} /> : null}
    <Dialog open={props.open} onClose={handleDailogClose} maxWidth="md" fullWidth>
      <Box sx={{...dialogEditEvent, backgroundColor: lightcolor, border: "1px solid #D9D9D9" }}>
        <Grid container xs={12} align="center" sx={{ textAlign: "left" }}>
          <Grid item xs={11}>
            <Typography sx={{ color: pcolor, fontWeight: "bold", fontSize: "20px", textTransform: "capitalize" }}>
              Add Symptom / Progress / Side effect
            </Typography>
          </Grid>
          <Grid item xs={1} sx={{ color: rcolor, textAlign: "right", cursor: "pointer" }}>
            <CloseIcon onClick={handleDailogClose} sx={{ width: "35px", height: "35px" }} />
          </Grid>
        </Grid>
        <DialogContent sx={{ padding: "5px" }}>
          <Box sx={{ '& .MuiTextField-root': { m: 1, width: '100%', border: "0px" } }} noValidate autoComplete="off">
            <div style={{ minHeight: "380px", maxHeight: "500px", overflowY: "auto", backgroundColor: "#fff", borderRadius: "10px", padding: "10px" }}>
              <Box style={{ padding: "8px", marginTop: "10px" }}>
                <label style={{ color: pcolor, display: "block", fontWeight: "bold", marginBottom: "10px" }}>Date *</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker fullWidth value={journalDate} maxDate={dayjs()} onChange={(newValue) => setJournalDate(newValue)} />
                </LocalizationProvider>
                {journalDateValidMessage !== "" ? <span style={{ color: "red" }}>{journalDateValidMessage}</span> : null}
              </Box>
              <Box style={{ padding: "8px", marginTop: "10px" }}>
                <label style={{ color: pcolor, display: "block", fontWeight: "bold", marginBottom: "10px" }} onClick={() => { setShowMedicalConditionModal(true); }}>Symptoms</label>
                <div style={{ backgroundColor: lightcolor, borderRadius: "10px", margin: "10px 0px", padding: "10px", cursor: "pointer" }}
                  onClick={() => { setShowMedicalConditionModal(true); }}>
                  {renderSelectedSymptoms()}
                </div>
              </Box>
              <Box style={{ padding: "8px", marginTop: "10px" }}>
                <label style={{ color: pcolor, display: "block", fontWeight: "bold", marginBottom: "10px" }}>Note *</label>
                <TextField variant="outlined" placeholder="Write something here." fullWidth inputProps={{ maxLength: 450 }} multiline={true} maxRows={4} value={note} onChange={(e) => {
                  setNote(e.target.value);
                  if (e.target.value !== "") {
                    setNoteValidMessage('');
                  }
                }} />
                {noteValidMessage !== "" ? <span style={{ color: "red" }}>{noteValidMessage}</span> : null}
              </Box>
              <Box style={{ padding: "8px", marginTop: "10px" }}>
                <label style={{ color: pcolor, display: "block", fontWeight: "bold", marginBottom: "10px" }}>Add Attachments</label>
                {renderFiles()}
              </Box>
            </div>
            <Box sx={{ padding: "8x", marginTop: "10px", textAlign: "center" }}>
              {loading ? <CircularProgress /> : <Button type="button" sx={buttonRed} disabled={loading} onClick={() => { saveJournalEntry(); }}>Save</Button>}
              {error !== "" ? <Typography sx={{ padding: "5px", color: "red" }}>{error}</Typography> : null}
            </Box>
          </Box>
        </DialogContent>
      </Box>
    </Dialog>
  </>);
}